/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Components_Changelist_ErrorInputs */

const id_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const ms_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ralat: ${i?.message}`)
};

const da_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fejl: ${i?.message}`)
};

const de_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler: ${i?.message}`)
};

const en_us2_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const es_es2_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const es_mx2_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fil_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fr_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.message}`)
};

const it_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore: ${i?.message}`)
};

const hu_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hiba: ${i?.message}`)
};

const nl_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fout: ${i?.message}`)
};

const no_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feil: ${i?.message}`)
};

const pl_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Błąd: ${i?.message}`)
};

const pt_br2_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const pt_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro: ${i?.message}`)
};

const ro_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eroare: ${i?.message}`)
};

const fi_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Virhe: ${i?.message}`)
};

const sv_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fel: ${i?.message}`)
};

const vi_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lỗi: ${i?.message}`)
};

const tr_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata: ${i?.message}`)
};

const cs_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chyba: ${i?.message}`)
};

const bg_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Грешка: ${i?.message}`)
};

const ru_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка: ${i?.message}`)
};

const uk_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Помилка: ${i?.message}`)
};

const ar_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خطأ: ${i?.message}`)
};

const hi_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`त्रुटि: ${i?.message}`)
};

const th_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด: ${i?.message}`)
};

const ja_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラー：${i?.message}`)
};

const zh_cn2_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const zh_hant1_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const ko_components_changelist_error = /** @type {(inputs: Components_Changelist_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error: {message}" |
*
* @param {Components_Changelist_ErrorInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelist_error = /** @type {((inputs: Components_Changelist_ErrorInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelist_ErrorInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelist_error(inputs)
	if (locale === "ms") return ms_components_changelist_error(inputs)
	if (locale === "da") return da_components_changelist_error(inputs)
	if (locale === "de") return de_components_changelist_error(inputs)
	if (locale === "en-US") return en_us2_components_changelist_error(inputs)
	if (locale === "es-ES") return es_es2_components_changelist_error(inputs)
	if (locale === "es-MX") return es_mx2_components_changelist_error(inputs)
	if (locale === "fil") return fil_components_changelist_error(inputs)
	if (locale === "fr") return fr_components_changelist_error(inputs)
	if (locale === "it") return it_components_changelist_error(inputs)
	if (locale === "hu") return hu_components_changelist_error(inputs)
	if (locale === "nl") return nl_components_changelist_error(inputs)
	if (locale === "no") return no_components_changelist_error(inputs)
	if (locale === "pl") return pl_components_changelist_error(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelist_error(inputs)
	if (locale === "pt") return pt_components_changelist_error(inputs)
	if (locale === "ro") return ro_components_changelist_error(inputs)
	if (locale === "fi") return fi_components_changelist_error(inputs)
	if (locale === "sv") return sv_components_changelist_error(inputs)
	if (locale === "vi") return vi_components_changelist_error(inputs)
	if (locale === "tr") return tr_components_changelist_error(inputs)
	if (locale === "cs") return cs_components_changelist_error(inputs)
	if (locale === "bg") return bg_components_changelist_error(inputs)
	if (locale === "ru") return ru_components_changelist_error(inputs)
	if (locale === "uk") return uk_components_changelist_error(inputs)
	if (locale === "ar") return ar_components_changelist_error(inputs)
	if (locale === "hi") return hi_components_changelist_error(inputs)
	if (locale === "th") return th_components_changelist_error(inputs)
	if (locale === "ja") return ja_components_changelist_error(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelist_error(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelist_error(inputs)
	return ko_components_changelist_error(inputs)
});
export { components_changelist_error as "components.changelist.error" }